import { render, staticRenderFns } from "./ResponsiveSkipLinks.vue?vue&type=template&id=52a287f3&"
import script from "./ResponsiveSkipLinks.vue?vue&type=script&lang=js&"
export * from "./ResponsiveSkipLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a287f3')) {
      api.createRecord('52a287f3', component.options)
    } else {
      api.reload('52a287f3', component.options)
    }
    module.hot.accept("./ResponsiveSkipLinks.vue?vue&type=template&id=52a287f3&", function () {
      api.rerender('52a287f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/responsive/ResponsiveSkipLinks.vue"
export default component.exports